import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  categoriesWithJobs: [],
  filteredData: {},
  roundData: {},
  detailedReport: [],
};

/**
 * @memberOf module:ManageJob
 * @namespace store
 * @description central store for manage job module
 */
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
